import React, { useState } from 'react';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';

import { useAuth } from '../../utils/useAuth';

import { makeStyles } from '@material-ui/core/styles';
import { useForm } from 'react-hook-form';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardHeader: {
    color: theme.palette.getContrastText(theme.palette.primary.main),
    backgroundColor: theme.palette.primary.main,
  },
  textField: {
    margin: theme.spacing(1),
    width: '50%',
  },
  cardContent: {
    padding: theme.spacing(4),
  },
  cardActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

const ResetPassword = () => {
  const { resetPassword } = useAuth();

  const [hasSubmitted, setHasSubmitted] = useState(false);
  const { register, handleSubmit, errors } = useForm();

  const classes = useStyles();

  function handleResetSubmit({ email }) {
    if (email) {
      resetPassword(email)
        .then(() => {
          setHasSubmitted(true);
        })
        .catch((err) => console.log(err));
    } else {
      alert('Please enter an email address.');
    }
  }

  return (
    <Container>
      <Grid className={classes.root} container>
        <Grid item xs={12} sm={6}>
          <Card>
            <CardHeader
              className={classes.cardHeader}
              title="Password Reset"
            ></CardHeader>
            <CardContent className={classes.cardContent}>
              {hasSubmitted ? (
                <div style={{ display: 'flex' }}>
                  <Typography>
                    Thanks! We&#39;ve emailed a reset link to you.{' '}
                  </Typography>
                  <Link href="/signin">
                    <Typography>Back to sign in.</Typography>
                  </Link>
                </div>
              ) : (
                <form
                  id="reset-form"
                  onSubmit={handleSubmit(handleResetSubmit)}
                >
                  <TextField
                    error={!!errors.email}
                    helperText={!!errors.email && errors.email.message}
                    fullWidth
                    inputRef={register({
                      required: {
                        value: true,
                        message: 'Please enter your email.',
                      },
                    })}
                    label="Email Address"
                    name="email"
                    style={{ marginTop: '16px' }}
                    type="email"
                    variant="outlined"
                  ></TextField>
                </form>
              )}
            </CardContent>
            <CardActions className={classes.cardActions}>
              <Button
                color="primary"
                form="reset-form"
                fullWidth
                size="large"
                type="submit"
                variant="contained"
              >
                Submit
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ResetPassword;
